
import { component } from '@/helpers/vueTyped';
import { Tournaments, TournamentSport } from './types';
import store, { dispatch } from '@/store';
import ContextMenu from '@/components/Sport/ContextMenu.vue';

interface RouteListenerProps {
  sportFeedId: string;
  tournamentFeedId: string;
}

export default component<RouteListenerProps>()({
  props: {
    sportFeedId: {},
    tournamentFeedId: {},
  },

  computed: {
    tournaments(): Tournaments { return store.state.tournaments; },

    sportTournaments(): TournamentSport {
      return this.tournaments[this.sportFeedId];
    },

    contextMenuTab() {
      return this.$route.meta.contextMenuTab;
    },
  },

  watch: {
    sportFeedId() {
      dispatch('setCurrentSport', [this.sportFeedId]);
    },

    tournamentFeedId() {
      dispatch('setCurrentTournament', [this.tournamentFeedId]);
    },

    contextMenuTab() {
      dispatch('setCurrentContextMenu', [this.contextMenuTab]);
    },
  },

  created() {
    dispatch('setCurrentSport', [this.sportFeedId]);
    dispatch('setCurrentTournament', [this.tournamentFeedId]);
    dispatch('setCurrentContextMenu', [this.$route.meta.contextMenuTab]);
  },

  render() {
    return (
      <div>
        <ContextMenu ref='contextmenu' selectOptions={this.sportTournaments} />
        <router-view key={`${this.sportFeedId}/${this.tournamentFeedId}`}/>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-55698079/RouteListener.vue" });